import type { ReactNode } from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

const CONVERSATION_GRADIENT_BACKGROUND =
  'radial-gradient(31.73% 23.84% at 29.6% 31.31%, rgba(255, 251, 215, 0.50) 0%, rgba(255, 246, 166, 0.00) 100%), radial-gradient(28.13% 19.11% at 63.87% 45.41%, rgba(255, 152, 226, 0.10) 0%, rgba(255, 152, 226, 0.00) 100%), radial-gradient(48.18% 38.48% at 23.6% 50%, rgba(255, 102, 92, 0.10) 0%, rgba(255, 102, 92, 0.00) 100%), radial-gradient(52.3% 37.41% at 66.27% 59.63%, rgba(210, 234, 255, 0.70) 0%, rgba(210, 234, 255, 0.00) 100%), linear-gradient(180deg, #FFF 0%, #F6F5F3 32.81%, #FEE6F2 72.4%, #F1E7E4 100%)'

export const ConversationGradientBackground = (): ReactNode => {
  const { bottom } = useSafeAreaInsets()

  return (
    <div className="absolute top-0 left-0 right-0" style={{ bottom, background: CONVERSATION_GRADIENT_BACKGROUND }} />
  )
}
